<template>
  <div class="block card">
    <title-block title="Mon équipe" :imagePath="logoBlockMonEquipe" imageAlt="logo"></title-block>
    <div class="block_content" v-if="entityId">
      <div class="mt-3 d-flex justify-content-between align-items-center">
        <div class="progress">
          <div v-if="percentOfPending > 0"
              class="progress-bar pending-state"
              :class="progressPendingClasses"
              :style="`width: ${percentOfPending}%`">
            <div class='progress-number'>{{ numberOfPending }}</div>
          </div>
          <div v-if="percentOfConfirmed > 0"
              class="progress-bar confimed-state"
              :class="progressConfirmedClasses"
              :style="`width: ${percentOfConfirmed}%`">
            <div class='progress-number'>{{ numberOfConfirmed }}</div>
          </div>
          <div v-if="percentOfActive > 0"
            class="progress-bar active-state"
            :class="progressActiveClasses"
            :style="`width: ${percentOfActive}%`">
            <div class='progress-number'>{{ numberOfActive }}</div>
          </div>
        </div>
        <div class="progress-total">{{ numberOfUsers }}</div>
      </div>
      <div class="mt-2 justify-content-center charts">
        <div class="mr-3 d-flex align-items-center legends">
          <div class="mr-1 point pending-state"></div>
          <span class="text">{{ $t('DashboardPageManager.AwaitingCandidateProgressBlock.pending') }}</span>
        </div>
        <div class="mr-3 d-flex align-items-center legends">
          <div class="mr-1 point confimed-state"></div>
          <span class="text">{{ $t('DashboardPageManager.AwaitingCandidateProgressBlock.confirmed') }}</span>
        </div>
        <div class="d-flex align-items-center legends">
          <div class="mr-1 point active-state"></div>
          <span class="text">{{ $t('DashboardPageManager.AwaitingCandidateProgressBlock.actived') }}</span>
        </div>
      </div>
    </div>
    <div class="block_content" v-else>
      <div class="mt-3 d-flex align-items-center choose_entity">
        {{ $t('DashboardPageManager.AwaitingCandidateBlock.choose_entity') }}
      </div>
      <div class="mt-2 charts">
        <div class="mr-3 d-flex legends">
          <div class="mr-1 point"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBlock from '@/components/dashboard/manager/TitleBlock'
export default {
  name: "AwaitingCandidateProgressBlock",
  props: ['numberOfPending', 'numberOfConfirmed', 'numberOfActive', 'entityId'],
  components: {
    TitleBlock
  },
  computed: {
    logoBlockMonEquipe() {
      return require('@/assets/img/icons8-conference-100.png')
    },
    numberOfUsers() {
      return this.numberOfConfirmed + this.numberOfActive + this.numberOfPending
    },
    percentOfPending() {
      return this.numberOfPending * 100 / this.numberOfUsers
    },
    percentOfConfirmed() {
      return this.numberOfConfirmed * 100 / this.numberOfUsers
    },
    percentOfActive() {
      return this.numberOfActive * 100 / this.numberOfUsers
    },
    progressPendingClasses() {
      return { 'text-under': this.isSmall(this.percentOfPending) };
    },
    progressConfirmedClasses() {
      if (this.isSmall(this.percentOfConfirmed)) {
        if (this.isSmall(this.percentOfPending) || this.isSmall(this.percentOfActive)) {
          return { 'text-over': this.isSmall(this.percentOfConfirmed) };
        } else {
          return { 'text-under': this.isSmall(this.percentOfConfirmed) };
        }
      }
      return {};
    },
    progressActiveClasses() {
      return { 'text-under': this.isSmall(this.percentOfActive) };
    }
  },
  methods: {
    isSmall(percent) {
      if (this.numberOfUsers < 100) {
        return percent < 3;
      } else {
        return percent < 5;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .charts {
    .legends {
      .point {
        width: 11px;
        height: 11px;
        font-weight: bold;
        border-radius: 50%;
      }

      .text {
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        fill: #333333;
        color: #333333
      }
    }
  }

  .progress {
    flex-grow: 1;
    margin: 0px 5px;
    height: 25px;
    border-radius: 25px;
    overflow: unset;

    .progress-bar {
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
    }

    .progress-bar {

      &.text-under, &.text-over {
        position: relative;

        &.pending-state {
          color: #e64e27;
        }

        &.active-state {
          color: #01a84d;
        }

        &.confimed-state {
          color: #6f1fdb;
        }

        .progress-number {
          position: absolute;
        }
      }

      &.text-under {
        .progress-number {
          top: 25px;
        }
      }

      &.text-over {
        .progress-number {
          top: -17px;
        }
      }
    }

    .progress-bar:first-child {
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
    }

    .progress-bar:last-child {
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
    }
  }

  .progress-total {
    color: #1f2929;
    font-weight: bold;
    font-size: 18px;
  }

  .pending-state {
    background-image: linear-gradient(to right, #e64e27 , #fb942a);
  }

  .confimed-state {
    background-image: linear-gradient(to right, #6f1fdb, #a264fa);
  }

  .active-state {
    background-image: linear-gradient(to right, #01a84d, #a1d97a);
  }

  .choose_entity {
    color: #85858e;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manager/AwaitingCandidateProgressBlock.vue